export const CATEGORY_NAME_MAP: Record<string, string> = {
  'New User Welcome Bonuses': 'Day-one moves',
  'Financial Health & Punctuality': 'On time, every time',
  'Deep Engagement & Stickiness': 'In it for the long haul',
  'Community & Social Growth': 'Spread the word',
  'Milestone & Seasonal Events': 'Milestones and seasonal moments',
};

export const getDisplayCategoryName = (apiCategoryName: string): string => {
  return CATEGORY_NAME_MAP[apiCategoryName] || apiCategoryName;
};
